<script setup>
import { computed, nextTick, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useArrowsAiAssistants } from 'dashboard/composables/useArrowsAiAssistants';
import PageLayout from 'dashboard/components-next/arrowsAi/PageLayout.vue';
import EmptyState from 'dashboard/components-next/arrowsAi/EmptyState.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { assistants, activeAssistantId, isLoading } = useArrowsAiAssistants();
const layoutRef = ref(null);

const openCreate = () => {
  nextTick(() => layoutRef.value?.openCreate());
};

const goToAssistant = (
  assistantId,
  name = 'arrows_ai_assistants_instructions'
) => {
  router.push({
    name,
    params: { accountId: route.params.accountId, assistantId },
  });
};

watch(
  [assistants, isLoading],
  ([list, loading]) => {
    if (loading || route.name !== 'arrows_ai_assistants_index') return;
    if (list.length && activeAssistantId.value) {
      goToAssistant(activeAssistantId.value, 'arrows_ai_assistants_overview');
    }
  },
  { immediate: true }
);

const isEmpty = computed(() => !isLoading.value && !assistants.value.length);
</script>

<template>
  <PageLayout
    ref="layoutRef"
    :header-title="t('ARROWS_AI.ASSISTANTS.HEADER')"
    :is-empty="isEmpty"
  >
    <template #emptyState>
      <EmptyState
        :title="t('ARROWS_AI.ASSISTANTS.EMPTY_TITLE')"
        :subtitle="t('ARROWS_AI.ASSISTANTS.EMPTY_SUBTITLE')"
        :action-label="t('ARROWS_AI.ASSISTANTS.ADD_NEW')"
        @click="openCreate"
      />
    </template>
  </PageLayout>
</template>
